import { render, staticRenderFns } from "./ResidualValuesVersionDetail_daag.vue?vue&type=template&id=37d321fe&scoped=true"
import script from "./ResidualValuesVersionDetail_daag.vue?vue&type=script&lang=js"
export * from "./ResidualValuesVersionDetail_daag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d321fe",
  null
  
)

export default component.exports